// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var ReactDraftWysiwyg = require("react-draft-wysiwyg");

function Editor(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ReactDraftWysiwyg.Editor, {
                      wrapperClassName: "w-1/2"
                    }),
                JsxRuntime.jsx("div", {
                      children: "Html Preview",
                      className: "w-1/2"
                    })
              ],
              className: "flex"
            });
}

var defaultHtml = "<p> hello </p>";

var make = Editor;

exports.defaultHtml = defaultHtml;
exports.make = make;
/* react/jsx-runtime Not a pure module */
